import { isAxiosError } from 'axios';
import { WireValueError } from '../services/WireValueNormalizer';

export type RunPhase = 'payload preparation' | 'calculation' | 'project save' | 'submission' | 'results processing';

/** Uses known routes rather than server messages/URLs, which may contain project or session data. */
export function getRunErrorMessage(error: unknown, phase: RunPhase): string | null {
    // Raised before any request, whichever phase reports it (submit catch or Execute submitFailed).
    if (error instanceof WireValueError) {
        return `Invalid value for ${error.fieldPath} (${error.reason}). Please correct it and try again.\nRUN/payload preparation`;
    }
    if (phase === 'results processing') {
        return 'The calculation completed, but its results could not be displayed. Please try again.\nRUN/results processing';
    }
    const status = isAxiosError(error) ? error.response?.status : undefined;
    if (status === 401 || status === 403) return null; // httpClient handles authentication alerts.

    const code = isAxiosError(error) ? error.code : undefined;
    const reason =
        code === 'ECONNABORTED' || code === 'ETIMEDOUT'
            ? 'timeout'
            : status && status > 0
              ? `HTTP ${status}`
              : code === 'ERR_NETWORK' || (isAxiosError(error) && error.request)
                ? 'network unavailable'
                : '';
    const route = phase === 'calculation' ? 'PUT /api/project_results/{id}' : phase === 'project save' ? 'PUT /api/Project/projects/{id}' : '';
    let message =
        phase === 'payload preparation'
            ? 'Project data could not be prepared. Please try again.'
            : phase === 'project save'
              ? 'The project could not be saved. Please try again.'
              : 'The calculation could not be completed. Please try again.';
    if (phase === 'submission' && error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
        message = error.message
            .split('\n')[0]
            .replace(/https?:\/\/\S+/gi, '[request]')
            .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '{id}');
    }
    return `${message}\n${[`RUN/${phase}`, reason, route].filter(Boolean).join(' — ')}`;
}
